export const GET_ALL_ACCA7 = "GET_ALL_ACCA7"
export const GET_ALL_ACCA7_RESPONSE_SUCCESS =
  "GET_ALL_ACCA7_RESPONSE_SUCCESS"
export const CREATE_ACCA7 = "CREATE_ACCA7"
export const UPDATE_ACCA7 = "UPDATE_ACCA7"
export const DELETE_ACCA7 = "DELETE_ACCA7"
